<h2 mat-dialog-title>
  {{ 'CUSTOMIZE_SALES_ORDERS_CONFIG.RESTORE_WARNING_DIALOG.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <p>
    {{
      'CUSTOMIZE_SALES_ORDERS_CONFIG.RESTORE_WARNING_DIALOG.TEXT_1' | translate
    }}
  </p>
  <p>
    {{
      'CUSTOMIZE_SALES_ORDERS_CONFIG.RESTORE_WARNING_DIALOG.TEXT_2' | translate
    }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button matDialogClose tabindex="-1">
    {{
      'CUSTOMIZE_SALES_ORDERS_CONFIG.RESTORE_WARNING_DIALOG.CANCEL' | translate
    }}
  </button>
  <button mat-raised-button color="primary" (click)="continueRestore()">
    {{
      'CUSTOMIZE_SALES_ORDERS_CONFIG.RESTORE_WARNING_DIALOG.RESTORE' | translate
    }}
  </button>
</mat-dialog-actions>
